import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { setCredentials } from "../../redux/slices/authSlice";
import { useUpdateUserMutation } from "../../redux/slices/usersApiSlice";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import {
  Activity,
  ArrowLeft,
  ArrowRight,
  BadgeCheck,
  BarChart3,
  Bell,
  CalendarDays,
  Camera,
  Check,
  ChevronRight,
  CircleUserRound,
  Clipboard,
  Copy,
  CreditCard,
  Edit3,
  ExternalLink,
  FileText,
  Image as ImageIcon,
  Link2,
  Loader2,
  MapPin,
  Menu,
  Moon,
  MoreHorizontal,
  Phone,
  Plus,
  RefreshCw,
  Search,
  Save,
  Settings2,
  ShieldCheck,
  Sparkles,
  Sun,
  Trash2,
  TrendingUp,
  UserPlus,
  Users,
  Wallet,
  X,
  Zap,
} from "lucide-react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const API = process.env.REACT_APP_API_BASE_URL;

const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userInfo } = useSelector((state) => state.auth);

  const [updateUser] = useUpdateUserMutation();

  const [email, setEmail] = useState("");
  const [activeTab, setActiveTab] = useState("profile");
  const [name, setName] = useState("");
  const [card, setCard] = useState("");
  const [referralLink, setReferralLink] = useState("");

  const [photo, setPhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);

  const [referredUsers, setReferredUsers] = useState([]);
  const [referredUserss, setReferredUserss] = useState([]);
  const [referredUsersz, setReferredUsersz] = useState([]);

  const [showInfo, setShowInfo] = useState(false);

  const [solGrupSayisi, setSolGrupSayisi] = useState({
    total: 0,
    paid: 0,
  });

  const [sagGrupSayisi, setSagGrupSayisi] = useState({
    total: 0,
    paid: 0,
  });

  const [referrerInfo, setReferrerInfo] = useState(null);
  const [referrerInfoo, setReferrerInfoo] = useState(null);
  const [referrerInf, setReferrerInf] = useState(null);
  const [referrerInfs, setReferrerInfs] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [showModa, setShowModa] = useState(false);

  const [paymentFilter, setPaymentFilter] = useState(null);
  const [paymentFilters, setPaymentFilters] = useState(null);

  const [stats, setStats] = useState(null);
  const [salaryData, setSalaryData] = useState(null);

  const [error, setError] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchTert, setSearchTert] = useState("");

  const [loading, setLoading] = useState(false);

  const [elanData, setElanData] = useState([]);

  const [editingAd, setEditingAd] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [newPhotos, setNewPhotos] = useState([]);

  const [deletingAdId, setDeletingAdId] = useState(null);
  const [deletingPhotoUrl, setDeletingPhotoUrl] = useState(null);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const [theme, setTheme] = useState(
    localStorage.getItem("theme") || "light"
  );

  const scrollRef = useRef(null);

  const MySwal = withReactContent(Swal);

  /* =========================================================
     HELPERS
  ========================================================= */

  const getErrorMessage = useCallback(
    (error, fallback = "Əməliyyat zamanı xəta baş verdi.") => {
      const responseData = error?.response?.data;

      const backendMessage =
        (typeof responseData === "string" && responseData.trim()) ||
        responseData?.message ||
        responseData?.error ||
        responseData?.details;

      if (backendMessage) return backendMessage;

      if (!error?.response) {
        return "Serverə qoşulmaq mümkün olmadı. İnternet bağlantınızı yoxlayın və yenidən cəhd edin.";
      }

      switch (error.response.status) {
        case 400:
          return "Göndərilən məlumatlar düzgün deyil.";
        case 401:
          return "Sessiyanız başa çatıb. Zəhmət olmasa yenidən daxil olun.";
        case 403:
          return "Bu əməliyyatı yerinə yetirmək üçün icazəniz yoxdur.";
        case 404:
          return "Axtarılan məlumat tapılmadı.";
        case 413:
          return "Yüklədiyiniz fayl çox böyükdür.";
        case 415:
          return "Bu fayl formatı dəstəklənmir.";
        case 422:
          return "Daxil etdiyiniz məlumatlar düzgün deyil.";
        case 500:
          return "Serverdə daxili xəta baş verdi.";
        default:
          return fallback;
      }
    },
    []
  );

  const showOperationError = useCallback(
    (title, error, fallback) => {
      return MySwal.fire({
        icon: "error",
        title,
        text: getErrorMessage(error, fallback),
        confirmButtonText: "Bağla",
        confirmButtonColor: "#111827",
        customClass: {
          popup: "rounded-[28px] shadow-2xl",
          title: "text-xl font-bold",
          confirmButton: "rounded-xl px-6",
        },
      });
    },
    [MySwal, getErrorMessage]
  );

  const closeReferralModal = () => {
    setShowModal(false);
    setShowModa(false);
  };

  /* =========================================================
     THEME
  ========================================================= */

  useEffect(() => {
    const element = document.documentElement;

    if (theme === "dark") {
      element.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      element.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [theme]);

  /* =========================================================
     MOBILE DRAWER
  ========================================================= */

  useEffect(() => {
    if (!mobileMenuOpen) return;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [mobileMenuOpen]);

  /* =========================================================
     USER PAYMENT CHECK
  ========================================================= */

  useEffect(() => {
    if (!userInfo?._id) {
      navigate("/");
      return;
    }

    const checkPaymentStatus = async () => {
      try {
        const { data } = await axios.get(
          `${API}/api/users/getuser/${userInfo._id}`,
          { withCredentials: true }
        );

        if (data.payment === false) {
          navigate("/");
        }
      } catch (err) {
        if (
          err.response &&
          (err.response.status === 401 || err.response.status === 403)
        ) {
          navigate("/");
        } else {
          console.error(
            "İstifadəçinin ödəniş statusunu yoxlamaq mümkün olmadı:",
            err
          );
        }
      }
    };

    checkPaymentStatus();
  }, [userInfo?._id, navigate]);

  /* =========================================================
     BASIC USER DATA
  ========================================================= */

  useEffect(() => {
    if (!userInfo) return;

    setName(userInfo.name || "");
    setEmail(userInfo.email || "");
    setPhoto(userInfo.photo || null);
    setReferralLink(userInfo.referralCode || "");
    setCard(userInfo.card || "");
  }, [userInfo]);

  /* =========================================================
     FETCH TEAM DATA
  ========================================================= */

  const fetchTeamData = useCallback(async () => {
    if (!userInfo?.referralCode) return;

    try {
      const [directRes, referralRes, adminRes] = await Promise.all([
        axios.get(
          `${API}/api/users/user/${userInfo.referralCode}`,
          { withCredentials: true }
        ),
        axios.get(
          `${API}/api/users/refCode/${userInfo.referralCode}`,
          { withCredentials: true }
        ),
        axios.get(
          `${API}/api/users/admin/${userInfo.referralCode}`,
          { withCredentials: true }
        ),
      ]);

      setReferredUserss(directRes?.data?.users || []);
      setReferredUsersz(referralRes?.data?.referredUsers || []);

      const users = adminRes?.data?.users || [];

      setReferredUsers(users);

      const rightUser = users.find(
        (user) =>
          String(user.side || "").trim().toLowerCase() === "right"
      );

      const leftUser = users.find(
        (user) =>
          String(user.side || "").trim().toLowerCase() === "left"
      );

      const rightPromise = rightUser?.referralCode
        ? axios.get(
            `${API}/api/users/user/${rightUser.referralCode}`,
            { withCredentials: true }
          )
        : Promise.resolve({ data: { users: [] } });

      const leftPromise = leftUser?.referralCode
        ? axios.get(
            `${API}/api/users/user/${leftUser.referralCode}`,
            { withCredentials: true }
          )
        : Promise.resolve({ data: { users: [] } });

      const [rightRes, leftRes] = await Promise.all([
        rightPromise,
        leftPromise,
      ]);

      const rightGroup = rightRes?.data?.users || [];
      const leftGroup = leftRes?.data?.users || [];

      setSagGrupSayisi({
        total: rightGroup.length,
        paid: rightGroup.filter((u) => u.payment === true).length,
      });

      setSolGrupSayisi({
        total: leftGroup.length,
        paid: leftGroup.filter((u) => u.payment === true).length,
      });
    } catch (err) {
      if (err.response?.status === 404) {
        setReferredUsers([]);
        setReferredUserss([]);
        setReferredUsersz([]);
      } else {
        console.error("Team data error:", err);
      }
    }
  }, [userInfo?.referralCode]);

  useEffect(() => {
    fetchTeamData();
  }, [fetchTeamData]);

  /* =========================================================
     FILTERED USERS
  ========================================================= */

  const filteredUsers = useMemo(() => {
    const search = (searchTerm || "").toLowerCase().trim();

    return referredUserss
      .filter((user) => user.isDeleted !== true)
      .filter((user) => {
        if (!search) return true;

        const userName = String(user.name || "").toLowerCase();
        const code = String(user.referralCode || "").toLowerCase();

        return (
          userName.includes(search) ||
          code.includes(search)
        );
      })
      .filter((user) => {
        if (paymentFilters === null) return true;

        return paymentFilters
          ? user.payment === true
          : user.payment === false;
      });
  }, [referredUserss, searchTerm, paymentFilters]);

  const filteredUserz = useMemo(() => {
    const search = (searchTert || "").toLowerCase().trim();

    return referredUsersz
      .filter((user) => {
        if (!search) return true;

        return (
          String(user.name || "")
            .toLowerCase()
            .includes(search) ||
          String(user.referralCode || "")
            .toLowerCase()
            .includes(search)
        );
      })
      .filter((user) => {
        if (paymentFilter === null) return true;

        return paymentFilter
          ? user.payment === true
          : user.payment === false;
      });
  }, [referredUsersz, searchTert, paymentFilter]);

  /* =========================================================
     PROFILE UPDATE
  ========================================================= */

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!card.trim()) {
      toast.error("Kart məlumatı tələb olunur!");
      return;
    }

    const formData = new FormData();
    formData.append("card", card);

    try {
      const res = await updateUser(formData).unwrap();

      dispatch(setCredentials({ ...res }));

      toast.success("Profil uğurla yeniləndi!");
      navigate("/");
    } catch (err) {
      toast.error(
        err?.data?.message ||
          err?.message ||
          "Xəta baş verdi."
      );
    }
  };

  /* =========================================================
     REFERRAL COPY
  ========================================================= */

  const copyReferralLink = async () => {
    try {
      await navigator.clipboard.writeText(
        `${window.location.origin}/register?referral=${referralLink}`
      );

      toast.success("Dəvət linkiniz kopyalandı!");
    } catch {
      toast.error("Dəvət linki kopyalana bilmədi.");
    }
  };

  const copyReferralLinke = async () => {
    try {
      await navigator.clipboard.writeText(referralLink);

      toast.success("İstifadəçi kodunuz kopyalandı!");
    } catch {
      toast.error("İstifadəçi kodunuz kopyalanmadı.");
    }
  };

  /* =========================================================
     PROFILE IMAGE
  ========================================================= */

  const handlePhotoChange = async (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    setPhoto(file);
    setPhotoPreview(URL.createObjectURL(file));

    const formData = new FormData();
    formData.append("profileImage", file);

    try {
      const res = await axios.post(
        `${API}/api/users/profile/uploadImage`,
        formData,
        {
          withCredentials: true,
        }
      );

      const cacheBustedUrl =
        res.data.imageUrl + "?v=" + Date.now();

      setPhoto(cacheBustedUrl);
      setPhotoPreview(null);

      dispatch(
        setCredentials({
          ...userInfo,
          photo: cacheBustedUrl,
        })
      );

      toast.success("Profil şəkli uğurla yükləndi!");
    } catch (err) {
      setPhoto(userInfo?.photo || null);
      setPhotoPreview(null);

      toast.error("Profil şəkli yüklənmədi!");
    }
  };

  /* =========================================================
     REFERRER
  ========================================================= */

  const handleNameClickl = async () => {
    try {
      const [res1, res2] = await Promise.all([
        axios.get(
          `${API}/api/users/get-link-owner/${userInfo.referralCode}`,
          { withCredentials: true }
        ),
        axios.get(
          `${API}/api/users/referredBykod/${userInfo.referralCode}`,
          { withCredentials: true }
        ),
      ]);

      setReferrerInf(res1.data);
      setReferrerInfs(res2.data);
      setShowModa(true);
    } catch {
      setReferrerInf({
        error: "Əsas dəvətçi tapılmadı.",
      });

      setReferrerInfs({
        error: "Əsas dəvətçi tapılmadı.",
      });

      setShowModa(true);
    }
  };

  const handleNameClick = async (referralCode) => {
    try {
      const [res1, res2] = await Promise.all([
        axios.get(
          `${API}/api/users/get-link-owner/${referralCode}`,
          { withCredentials: true }
        ),
        axios.get(
          `${API}/api/users/referredBykod/${referralCode}`,
          { withCredentials: true }
        ),
      ]);

      setReferrerInfo(res1.data);
      setReferrerInfoo(res2.data);
      setShowModal(true);
    } catch {
      setReferrerInfo({
        error: "Əsas dəvətçi tapılmadı.",
      });

      setReferrerInfoo({
        error: "Əsas dəvətçi tapılmadı.",
      });

      setShowModal(true);
    }
  };

  /* =========================================================
     PAYMENT MODAL
  ========================================================= */

  useEffect(() => {
    if (!userInfo?._id) return;

    const checkPaymentStatus = async () => {
      try {
        const { data } = await axios.get(
          `${API}/api/users/getuser/${userInfo._id}`,
          { withCredentials: true }
        );

        if (data.payment === false) {
          const response = await axios.get(
            `${API}/api/kart`,
            { withCredentials: true }
          );

          const kartlar = response.data.allKart || [];

          const kartHtml = kartlar
            .map(
              (item) => `
                <div
                  class="bg-gray-100 p-4 rounded-2xl flex items-center justify-between cursor-pointer border border-gray-200 mb-2 copyCard"
                  data-kart="${item.kart}"
                >
                  <span class="font-mono text-lg">${item.kart}</span>
                  <button class="text-blue-600 font-semibold text-sm ml-4">
                    Kopyala
                  </button>
                </div>
              `
            )
            .join("");

          MySwal.fire({
            title: `💳 Salam, ${data.name}!`,
            html: `
              <div style="text-align:left">
                <p style="font-size:15px;line-height:1.7;margin-bottom:16px">
                  Qeydiyyatınızı tamamlamaq üçün zəhmət olmasa ödəniş edin.
                  Ödəniş ayda cəmi 1 dəfə – <strong>15 AZN</strong> təşkil edir.
                  Ödənişdən sonra şəxsi kabinetiniz aktivləşir və qazancınız
                  avtomatik hesablanmağa başlayır.
                </p>

                <p style="font-size:14px;line-height:1.7;color:#64748b">
                  Ödəniş etdikdən sonra qəbzi WhatsApp-da administratora
                  və ya çat-bota göndərin ✅
                </p>

                <div style="margin-top:16px">
                  ${kartHtml}
                </div>
              </div>
            `,
            icon: "warning",
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: "Sonra",
            cancelButtonColor: "#64748b",
            background: theme === "dark" ? "#101217" : "#ffffff",
            color: theme === "dark" ? "#ffffff" : "#111827",
            customClass: {
              popup: "rounded-[28px] shadow-2xl",
              title: "text-2xl font-black",
            },
            didOpen: () => {
              const cards =
                document.querySelectorAll(".copyCard");

              cards.forEach((cardDiv) => {
                cardDiv.addEventListener("click", () => {
                  const kart =
                    cardDiv.getAttribute("data-kart");

                  navigator.clipboard.writeText(
                    kart.replace(/\s/g, "")
                  );

                  Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "Kart nömrəsi kopyalandı!",
                    showConfirmButton: false,
                    timer: 1800,
                  });
                });
              });
            },
          });
        }
      } catch (err) {
        console.error("Ödəniş statusu:", err);
      }
    };

    checkPaymentStatus();
  }, [userInfo?._id, theme, MySwal]);

  /* =========================================================
     STATS
  ========================================================= */

  useEffect(() => {
    if (!userInfo?.referralCode) return;

    const fetchStats = async () => {
      try {
        const res = await axios.get(
          `${API}/api/users/referral-stats/${userInfo.referralCode}`,
          { withCredentials: true }
        );

        setStats(res.data);
      } catch (err) {
        setError(
          err.response?.data?.message ||
            "Məlumatları əldə etmək mümkün olmadı."
        );
      }
    };

    fetchStats();
  }, [userInfo?.referralCode]);

  /* =========================================================
     SALARY
  ========================================================= */

  useEffect(() => {
    if (!userInfo?.referralCode) return;

    const fetchSalaryData = async () => {
      try {
        const response = await axios.get(
          `${API}/api/users/salary/${userInfo.referralCode}`,
          { withCredentials: true }
        );

        setSalaryData(response.data);
      } catch (err) {
        setError(
          err.response?.data?.message ||
            "Maaş verisi alınarkən xəta baş verdi."
        );
      }
    };

    fetchSalaryData();
  }, [userInfo?.referralCode]);

  /* =========================================================
     PAYMENT SUCCESS MESSAGE
  ========================================================= */

  useEffect(() => {
    if (!userInfo?._id) return;

    const fetchUserData = async () => {
      try {
        const { data: userData } = await axios.get(
          `${API}/api/users/getuser/${userInfo._id}`,
          { withCredentials: true }
        );

        const currentMonth =
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1);

        const shownMonth =
          localStorage.getItem("paymentShownMonth");

        if (userData.payment) {
          if (shownMonth !== currentMonth) {
            MySwal.fire({
              title: "Təbriklər!",
              html: `
                <p>
                  Uğura xoş gəlmisiniz!<br/>
                  Artıq siz rəsmi şəkildə sistemə daxil oldunuz.
                </p>

                <p style="margin-top:12px">
                  <strong>İndi nə etməli?</strong><br/>
                  WhatsApp qrupuna qoşulun, gündəlik təlimləri
                  izləyin və ilk qazancınızı əldə etməyə başlayın.
                </p>

                <p style="margin-top:16px">
                  <a
                    href="https://chat.whatsapp.com/GpXwAPiRHLHFIMz4BE7s5e?s=cl&p=a&mlu=4&ilr=4"
                    target="_blank"
                    rel="noreferrer"
                    style="color:#2563eb;font-weight:700"
                  >
                    WhatsApp Qrupuna Qoşul →
                  </a>
                </p>
              `,
              icon: "success",
              confirmButtonText: "Bağla",
              confirmButtonColor: "#111827",
              customClass: {
                popup: "rounded-[28px]",
              },
            });

            localStorage.setItem(
              "paymentShownMonth",
              currentMonth
            );
          }
        } else {
          localStorage.removeItem("paymentShownMonth");
        }
      } catch (err) {
        console.error(
          "Ödəniş statusu yoxlanılarkən xəta:",
          err
        );
      }
    };

    fetchUserData();
  }, [userInfo?._id, MySwal]);

  /* =========================================================
     ADS
  ========================================================= */

  const fetchElanData = useCallback(async () => {
    if (!userInfo?._id) return;

    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(
        `${API}/api/pagination/id/user/${userInfo._id}`,
        { withCredentials: true }
      );

      setElanData(response.data.products || []);
    } catch (err) {
      setError(
        getErrorMessage(
          err,
          "Elanlar yüklənərkən gözlənilməz xəta baş verdi."
        )
      );
    } finally {
      setLoading(false);
    }
  }, [userInfo?._id, getErrorMessage]);

  useEffect(() => {
    fetchElanData();
  }, [fetchElanData]);

  const handleDeleteSinglePhoto = async (id, photoUrl) => {
    const result = await MySwal.fire({
      icon: "warning",
      title: "Fotoşəkli silmək istəyirsiniz?",
      text: "Bu əməliyyat geri qaytarıla bilməz.",
      showCancelButton: true,
      confirmButtonText: "Bəli, sil",
      cancelButtonText: "Ləğv et",
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#64748b",
      reverseButtons: true,
      customClass: {
        popup: "rounded-[28px]",
      },
    });

    if (!result.isConfirmed) return;

    try {
      setDeletingPhotoUrl(photoUrl);

      const response = await axios.delete(
        `${API}/api/pagination/${id}/photo?url=${encodeURIComponent(
          photoUrl
        )}`,
        { withCredentials: true }
      );

      if (response.status === 200) {
        setEditingAd((prev) =>
          prev
            ? {
                ...prev,
                photo: (prev.photo || []).filter(
                  (p) => p !== photoUrl
                ),
              }
            : prev
        );

        setElanData((prev) =>
          prev.map((ad) =>
            ad._id === id
              ? {
                  ...ad,
                  photo: (ad.photo || []).filter(
                    (p) => p !== photoUrl
                  ),
                }
              : ad
          )
        );

        await MySwal.fire({
          icon: "success",
          title: "Fotoşəkil silindi",
          text: "Fotoşəkil elandan uğurla silindi.",
          confirmButtonText: "Bağla",
          confirmButtonColor: "#111827",
          timer: 1600,
          timerProgressBar: true,
          customClass: {
            popup: "rounded-[28px]",
          },
        });
      }
    } catch (err) {
      await showOperationError(
        "Fotoşəkil silinmədi",
        err,
        "Fotoşəkili silmək mümkün olmadı."
      );
    } finally {
      setDeletingPhotoUrl(null);
    }
  };

  const handleDeleteAd = async (id) => {
    const result = await MySwal.fire({
      icon: "warning",
      title: "Elanı silmək istəyirsiniz?",
      text: "Elan və ona bağlı məlumatlar silinəcək.",
      showCancelButton: true,
      confirmButtonText: "Bəli, sil",
      cancelButtonText: "Ləğv et",
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#64748b",
      reverseButtons: true,
      customClass: {
        popup: "rounded-[28px]",
      },
    });

    if (!result.isConfirmed) return;

    try {
      setDeletingAdId(id);
      setError(null);

      await axios.delete(
        `${API}/api/pagination/delete/${id}`,
        { withCredentials: true }
      );

      setElanData((prev) =>
        prev.filter((ad) => ad._id !== id)
      );

      await MySwal.fire({
        icon: "success",
        title: "Elan silindi",
        text: "Elanınız uğurla silindi.",
        confirmButtonText: "Bağla",
        confirmButtonColor: "#111827",
        timer: 1600,
        timerProgressBar: true,
        customClass: {
          popup: "rounded-[28px]",
        },
      });
    } catch (err) {
      await showOperationError(
        "Elan silinmədi",
        err,
        "Elanı silmək mümkün olmadı."
      );
    } finally {
      setDeletingAdId(null);
    }
  };

  const handleUpdateAd = async (e) => {
    e.preventDefault();

    if (!editingAd?._id) return;

    setUploading(true);
    setError(null);

    const formData = new FormData();

    formData.append("title", editingAd.title || "");
    formData.append(
      "description",
      editingAd.description || ""
    );
    formData.append("price", editingAd.price || 0);
    formData.append(
      "category",
      editingAd.category || ""
    );
    formData.append(
      "condition",
      editingAd.condition || "new"
    );
    formData.append("brand", editingAd.brand || "");
    formData.append("model", editingAd.model || "");
    formData.append("phone", editingAd.phone || "");
    formData.append(
      "location",
      editingAd.location || ""
    );
    formData.append(
      "distance",
      editingAd.distance || ""
    );
    formData.append(
      "delivery",
      editingAd.delivery || false
    );
    formData.append(
      "negotiable",
      editingAd.negotiable || false
    );
    formData.append(
      "warranty",
      editingAd.warranty || ""
    );
    formData.append(
      "stock",
      editingAd.stock || 1
    );
    formData.append(
      "status",
      editingAd.status || "active"
    );

    newPhotos.forEach((file) => {
      formData.append("photo", file);
    });

    try {
      await axios.put(
        `${API}/api/pagination/update/id/${editingAd._id}`,
        formData,
        { withCredentials: true }
      );

      setEditingAd(null);
      setNewPhotos([]);

      await fetchElanData();

      await MySwal.fire({
        icon: "success",
        title: "Elan yeniləndi",
        text: "Dəyişikliklər uğurla yadda saxlanıldı.",
        confirmButtonText: "Bağla",
        confirmButtonColor: "#111827",
        timer: 1600,
        timerProgressBar: true,
        customClass: {
          popup: "rounded-[28px]",
        },
      });
    } catch (err) {
      await showOperationError(
        "Elan yenilənmədi",
        err,
        "Dəyişiklikləri yadda saxlamaq mümkün olmadı."
      );
    } finally {
      setUploading(false);
    }
  };

  const handleDeleteNewPhoto = (idx) => {
    setNewPhotos((prev) =>
      prev.filter((_, i) => i !== idx)
    );
  };

  /* =========================================================
     DERIVED DATA
  ========================================================= */

  const activeMembers = useMemo(
    () =>
      referredUserss.filter(
        (u) => u.isDeleted !== true
      ).length,
    [referredUserss]
  );

  const totalTeam = solGrupSayisi.total + sagGrupSayisi.total;

  const paidTeam =
    solGrupSayisi.paid + sagGrupSayisi.paid;

  const leftPercentage =
    totalTeam > 0
      ? Math.round(
          (solGrupSayisi.total / totalTeam) * 100
        )
      : 0;

  const rightPercentage =
    totalTeam > 0
      ? Math.round(
          (sagGrupSayisi.total / totalTeam) * 100
        )
      : 0;

  const tabs = [
    {
      id: "profile",
      label: "Profil",
      icon: CircleUserRound,
    },
    {
      id: "groups",
      label: "Qollar",
      icon: GitBranchIcon,
    },
    {
      id: "qrouplar",
      label: "Komanda",
      icon: Users,
    },
    {
      id: "referrals",
      label: "Dəvətlər",
      icon: UserPlus,
    },
    {
      id: "elanlar",
      label: "Elanlar",
      icon: FileText,
    },
  ];

  const currentTab =
    tabs.find((tab) => tab.id === activeTab) ||
    tabs[0];

  /* =========================================================
     SMALL COMPONENTS
  ========================================================= */

  function GitBranchIcon({ size = 18, ...props }) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
      >
        <circle cx="6" cy="5" r="2.5" />
        <circle cx="18" cy="5" r="2.5" />
        <circle cx="12" cy="19" r="2.5" />
        <path d="M6 7.5v3a3 3 0 0 0 3 3h3" />
        <path d="M18 7.5v3a3 3 0 0 1-3 3h-3" />
        <path d="M12 13.5V16.5" />
      </svg>
    );
  }

  const StatCard = ({
    label,
    value,
    suffix,
    icon: Icon,
    accent = "blue",
  }) => {
    const accentMap = {
      blue: "text-blue-600 dark:text-blue-400 bg-blue-500/10",
      emerald:
        "text-emerald-600 dark:text-emerald-400 bg-emerald-500/10",
      violet:
        "text-violet-600 dark:text-violet-400 bg-violet-500/10",
      orange:
        "text-orange-600 dark:text-orange-400 bg-orange-500/10",
    };

    return (
      <div className="group relative overflow-hidden rounded-2xl sm:rounded-[24px] border border-slate-200/80 dark:border-white/[0.07] bg-white dark:bg-[#111318] p-3 sm:p-5 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_20px_50px_-30px_rgba(0,0,0,.35)]">
        <div className="flex items-start justify-between gap-3">
          <div>
            <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-slate-400">
              {label}
            </p>

            <div className="mt-2 flex items-baseline gap-1">
              <span className="text-xl sm:text-2xl font-black tracking-tight">
                {value}
              </span>

              {suffix && (
                <span className="text-xs font-bold text-slate-400">
                  {suffix}
                </span>
              )}
            </div>
          </div>

          <div
            className={`w-8 h-8 sm:w-10 sm:h-10 rounded-xl flex items-center justify-center ${accentMap[accent]}`}
          >
            <Icon size={18} />
          </div>
        </div>
      </div>
    );
  };

  const Avatar = ({
    user,
    size = "w-11 h-11",
    rounded = "rounded-2xl",
  }) => (
    <div
      className={`${size} ${rounded} overflow-hidden shrink-0 bg-slate-100 dark:bg-white/[0.06]`}
    >
      {user?.photo ? (
        <img
          src={user.photo}
          alt={user.name || "İstifadəçi"}
          className="w-full h-full object-cover"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center font-black text-slate-400">
          {user?.name?.charAt(0)?.toUpperCase() || "?"}
        </div>
      )}
    </div>
  );

  const EmptyState = ({
    icon: Icon = Users,
    title,
    description,
  }) => (
    <div className="py-16 px-6 text-center">
      <div className="mx-auto w-14 h-14 rounded-2xl bg-slate-100 dark:bg-white/[0.05] flex items-center justify-center">
        <Icon
          size={24}
          className="text-slate-400"
        />
      </div>

      <h3 className="mt-4 text-base font-black">
        {title}
      </h3>

      <p className="mt-1 text-sm text-slate-400 max-w-sm mx-auto">
        {description}
      </p>
    </div>
  );

  /* =========================================================
     RENDER
  ========================================================= */

  return (
    <div className="min-h-screen bg-[#f7f8fa] dark:bg-[#08090c] text-slate-950 dark:text-white transition-colors duration-300">
      <style>{`
        @keyframes drawerIn {
          from { transform: translateX(100%); opacity: .7; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
      {/* BACKGROUND */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-[300px] -right-[200px] w-[650px] h-[650px] rounded-full bg-blue-500/[0.055] dark:bg-blue-500/[0.07] blur-[120px]" />

        <div className="absolute top-[40%] -left-[300px] w-[600px] h-[600px] rounded-full bg-violet-500/[0.045] dark:bg-violet-500/[0.06] blur-[120px]" />
      </div>

      <div className="relative max-w-[1540px] mx-auto px-4 sm:px-6 lg:px-8 py-5 lg:py-8">
        {/* =====================================================
            HEADER
        ===================================================== */}

        <header className="flex items-center justify-between gap-3 mb-4 sm:mb-6 lg:mb-7">
          <div className="min-w-0">
            <button
              type="button"
              onClick={() => navigate("/")}
              className="hidden sm:inline-flex group items-center gap-2 text-[11px] font-black uppercase tracking-[0.16em] text-slate-400 hover:text-slate-950 dark:hover:text-white transition-colors"
            >
              <ArrowLeft
                size={14}
                className="group-hover:-translate-x-1 transition-transform"
              />

              Ana səhifə
            </button>

            <div className="mt-1.5 sm:mt-3">
              <h1 className="text-xl sm:text-3xl lg:text-[34px] font-black tracking-[-0.04em]">
                Şəxsi kabinet
              </h1>

              <p className="hidden sm:block mt-1 text-sm text-slate-500 dark:text-slate-400">
                Profilinizi, komandanızı və elanlarınızı idarə edin.
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2 shrink-0">
            <button
              type="button"
              onClick={() =>
                setTheme(
                  theme === "dark"
                    ? "light"
                    : "dark"
                )
              }
              className="w-11 h-11 rounded-2xl border border-slate-200 dark:border-white/[0.08] bg-white dark:bg-[#111318] flex items-center justify-center text-slate-500 dark:text-slate-300 hover:text-slate-950 dark:hover:text-white hover:shadow-lg transition-all"
              title="Temanı dəyiş"
            >
              {theme === "dark" ? (
                <Sun size={18} />
              ) : (
                <Moon size={18} />
              )}
            </button>

            <button
              type="button"
              onClick={() => navigate("/cedvel")}
              className="hidden sm:inline-flex h-11 px-4 rounded-2xl bg-slate-950 dark:bg-white text-white dark:text-slate-950 items-center gap-2 text-xs font-black hover:opacity-90 transition-opacity"
            >
              Cədvəl
              <ArrowRight size={15} />
            </button>

            <button
              type="button"
              onClick={() =>
                setMobileMenuOpen(
                  (prev) => !prev
                )
              }
              className="lg:hidden w-11 h-11 rounded-2xl border border-slate-200 dark:border-white/[0.08] bg-white dark:bg-[#111318] flex items-center justify-center"
            >
              <Menu size={19} />
            </button>
          </div>
        </header>

        {/* =====================================================
            HERO
        ===================================================== */}

        <section className="relative overflow-hidden rounded-[30px] border border-slate-200/80 dark:border-white/[0.07] bg-white dark:bg-[#101217] shadow-[0_25px_80px_-45px_rgba(15,23,42,.35)]">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-500/[0.055] via-transparent to-violet-500/[0.055]" />

          <div className="relative p-4 sm:p-7 lg:p-8">
            <div className="flex flex-col xl:flex-row xl:items-center gap-4 sm:gap-7">
              {/* AVATAR */}
              <div className="relative shrink-0 self-start">
                <div className="relative w-[76px] h-[76px] sm:w-28 sm:h-28 rounded-[24px] sm:rounded-[28px] p-[1px] bg-gradient-to-br from-blue-500/80 via-indigo-500/70 to-violet-500/70 shadow-[0_15px_40px_-15px_rgba(59,130,246,.5)]">
                  <div className="w-full h-full rounded-[23px] sm:rounded-[27px] overflow-hidden bg-slate-100 dark:bg-[#181a20]">
                    {photoPreview || photo ? (
                      <img
                        src={
                          photoPreview || photo
                        }
                        alt="Profil"
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-3xl font-black text-slate-400">
                        {name
                          ?.charAt(0)
                          ?.toUpperCase() || "?"}
                      </div>
                    )}
                  </div>
                </div>

                <label className="absolute -right-1.5 -bottom-1.5 sm:-right-2 sm:-bottom-2 w-9 h-9 sm:w-10 sm:h-10 rounded-2xl bg-slate-950 dark:bg-white text-white dark:text-slate-950 flex items-center justify-center cursor-pointer shadow-xl hover:scale-105 transition-transform border-[3px] border-white dark:border-[#101217]">
                  <Camera size={15} />

                  <input
                    type="file"
                    accept="image/*"
                    onChange={handlePhotoChange}
                    className="hidden"
                  />
                </label>
              </div>

              {/* USER */}
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span
                    className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-[10px] font-black uppercase tracking-wider ${
                      userInfo?.payment
                        ? "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400"
                        : "bg-orange-500/10 text-orange-600 dark:text-orange-400"
                    }`}
                  >
                    <span
                      className={`w-1.5 h-1.5 rounded-full ${
                        userInfo?.payment
                          ? "bg-emerald-500"
                          : "bg-orange-500"
                      }`}
                    />

                    {userInfo?.payment
                      ? "Aktiv hesab"
                      : "Ödəniş gözləyir"}
                  </span>

                  {salaryData?.rank && (
                    <span className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full bg-violet-500/10 text-violet-600 dark:text-violet-400 text-[10px] font-black uppercase tracking-wider">
                      <Sparkles size={11} />
                      {salaryData.rank}
                    </span>
                  )}
                </div>

                <h2 className="mt-2 sm:mt-3 text-xl sm:text-3xl font-black tracking-[-0.04em] truncate">
                  {name ||
                    userInfo?.name ||
                    "İstifadəçi"}
                </h2>

                <p className="mt-1 text-sm text-slate-500 dark:text-slate-400 truncate">
                  {email ||
                    userInfo?.email ||
                    "—"}
                </p>

                <div className="flex flex-wrap items-center gap-1.5 sm:gap-2 mt-3 sm:mt-4">
                  <div className="inline-flex items-center gap-2 px-3 py-2 rounded-xl bg-slate-100 dark:bg-white/[0.045] text-xs">
                    <span className="text-slate-400">
                      CODE
                    </span>

                    <span className="font-black">
                      {referralLink || "—"}
                    </span>
                  </div>

                  <div className="inline-flex items-center gap-2 px-3 py-2 rounded-xl bg-slate-100 dark:bg-white/[0.045] text-xs">
                    <Phone
                      size={12}
                      className="text-slate-400"
                    />

                    <span className="font-bold">
                      {userInfo?.phone || "—"}
                    </span>
                  </div>
                </div>
              </div>

              {/* QUICK STATS */}
              <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-3 gap-2 xl:min-w-[380px]">
                <StatCard
                  label="Maaş"
                  value={
                    salaryData?.salary || 0
                  }
                  suffix="₼"
                  icon={Wallet}
                  accent="emerald"
                />

                <StatCard
                  label="Mükafat"
                  value={
                    stats?.totalEarned || 0
                  }
                  suffix="₼"
                  icon={TrendingUp}
                  accent="blue"
                />

                <StatCard
                  label="Üzvlər"
                  value={activeMembers}
                  icon={Users}
                  accent="violet"
                />
              </div>
            </div>
          </div>
        </section>

        {/* =====================================================
            MOBILE RIGHT DRAWER
        ===================================================== */}

        {mobileMenuOpen && (
          <div className="lg:hidden fixed inset-0 z-[100]">
            <button
              type="button"
              aria-label="Menyunu bağla"
              onClick={() => setMobileMenuOpen(false)}
              className="absolute inset-0 w-full h-full bg-slate-950/45 dark:bg-black/65 backdrop-blur-[3px]"
            />

            <aside
              className="absolute top-0 right-0 h-[100dvh] w-[86%] max-w-[360px] bg-white dark:bg-[#0d0f13] border-l border-slate-200 dark:border-white/[0.08] shadow-[-30px_0_80px_-35px_rgba(0,0,0,.65)] animate-[drawerIn_.28s_ease-out]"
              aria-label="Mobil menyu"
            >
              <div className="h-full flex flex-col">
                <div className="px-4 pt-4 pb-3 border-b border-slate-100 dark:border-white/[0.06]">
                  <div className="flex items-center justify-between gap-3">
                    <div className="flex items-center gap-3 min-w-0">
                      <Avatar
                        user={userInfo}
                        size="w-11 h-11"
                        rounded="rounded-2xl"
                      />

                      <div className="min-w-0">
                        <p className="text-sm font-black truncate">
                          {userInfo?.name || "İstifadəçi"}
                        </p>
                        <p className="text-[11px] text-slate-400 truncate">
                          {userInfo?.email || "Şəxsi kabinet"}
                        </p>
                      </div>
                    </div>

                    <button
                      type="button"
                      onClick={() => setMobileMenuOpen(false)}
                      className="w-10 h-10 shrink-0 rounded-xl bg-slate-100 dark:bg-white/[0.06] flex items-center justify-center text-slate-500 dark:text-slate-300"
                    >
                      <X size={18} />
                    </button>
                  </div>
                </div>

                <div className="flex-1 overflow-y-auto px-3 py-4">
                  <p className="px-2 mb-2 text-[9px] font-black uppercase tracking-[0.22em] text-slate-400">
                    Kabinet
                  </p>

                  <div className="space-y-1.5">
                    {tabs.map((tab) => {
                      const Icon = tab.icon;
                      const active = activeTab === tab.id;

                      return (
                        <button
                          key={tab.id}
                          type="button"
                          onClick={() => {
                            setActiveTab(tab.id);
                            setMobileMenuOpen(false);
                          }}
                          className={`w-full flex items-center gap-3 rounded-2xl px-3 py-3.5 text-left transition-all ${
                            active
                              ? "bg-slate-950 text-white dark:bg-white dark:text-slate-950 shadow-lg"
                              : "text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-white/[0.05]"
                          }`}
                        >
                          <span
                            className={`w-9 h-9 rounded-xl flex items-center justify-center shrink-0 ${
                              active
                                ? "bg-white/10 dark:bg-black/10"
                                : "bg-slate-100 dark:bg-white/[0.05]"
                            }`}
                          >
                            <Icon size={17} />
                          </span>

                          <span className="flex-1 text-sm font-black">
                            {tab.label}
                          </span>

                          <ChevronRight size={16} className="opacity-45" />
                        </button>
                      );
                    })}
                  </div>

                  <div className="mt-5 rounded-2xl border border-slate-200 dark:border-white/[0.07] bg-slate-50 dark:bg-white/[0.025] p-4">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-[9px] font-black uppercase tracking-[0.18em] text-slate-400">
                          Komanda
                        </p>
                        <p className="mt-1 text-xl font-black">
                          {totalTeam}
                        </p>
                      </div>

                      <div className="w-9 h-9 rounded-xl bg-blue-500/10 text-blue-500 flex items-center justify-center">
                        <Users size={17} />
                      </div>
                    </div>

                    <div className="mt-4 grid grid-cols-2 gap-2">
                      <div className="rounded-xl bg-violet-500/[0.07] p-3">
                        <p className="text-[9px] font-black uppercase tracking-wider text-violet-500">
                          Sol
                        </p>
                        <p className="mt-1 text-base font-black">
                          {solGrupSayisi.total}
                        </p>
                      </div>

                      <div className="rounded-xl bg-blue-500/[0.07] p-3">
                        <p className="text-[9px] font-black uppercase tracking-wider text-blue-500">
                          Sağ
                        </p>
                        <p className="mt-1 text-base font-black">
                          {sagGrupSayisi.total}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="p-3 border-t border-slate-100 dark:border-white/[0.06]">
                  <button
                    type="button"
                    onClick={() =>
                      setTheme(theme === "dark" ? "light" : "dark")
                    }
                    className="w-full h-11 rounded-xl bg-slate-100 dark:bg-white/[0.05] flex items-center justify-between px-3 text-xs font-black"
                  >
                    <span className="flex items-center gap-2">
                      {theme === "dark" ? <Sun size={15} /> : <Moon size={15} />}
                      {theme === "dark" ? "Açıq tema" : "Tünd tema"}
                    </span>
                    <span className="text-slate-400">
                      {theme === "dark" ? "Light" : "Dark"}
                    </span>
                  </button>
                </div>
              </div>
            </aside>
          </div>
        )}

        {/* =====================================================
            MAIN LAYOUT
        ===================================================== */}

        <div className="grid grid-cols-1 lg:grid-cols-[235px_minmax(0,1fr)] gap-4 sm:gap-6 mt-4 sm:mt-6">
          {/* SIDEBAR */}
          <aside className="hidden lg:block lg:sticky lg:top-6 self-start">
            <div className="rounded-[26px] border border-slate-200/80 dark:border-white/[0.07] bg-white dark:bg-[#101217] p-2 shadow-sm">
              <div className="px-4 pt-4 pb-3">
                <p className="text-[9px] font-black uppercase tracking-[0.22em] text-slate-400">
                  Kabinet
                </p>
              </div>

              <div className="space-y-1">
                {tabs.map((tab) => {
                  const Icon = tab.icon;
                  const active =
                    activeTab === tab.id;

                  return (
                    <button
                      key={tab.id}
                      type="button"
                      onClick={() =>
                        setActiveTab(tab.id)
                      }
                      className={`relative w-full flex items-center gap-3 rounded-2xl px-3 py-3 text-left text-sm font-bold transition-all ${
                        active
                          ? "bg-slate-950 text-white dark:bg-white dark:text-slate-950 shadow-lg"
                          : "text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-white/[0.05] hover:text-slate-950 dark:hover:text-white"
                      }`}
                    >
                      <span
                        className={`w-8 h-8 rounded-xl flex items-center justify-center ${
                          active
                            ? "bg-white/10 dark:bg-black/10"
                            : "bg-slate-100 dark:bg-white/[0.045]"
                        }`}
                      >
                        <Icon size={16} />
                      </span>

                      <span className="flex-1">
                        {tab.label}
                      </span>

                      {active && (
                        <ChevronRight
                          size={15}
                          className="opacity-50"
                        />
                      )}
                    </button>
                  );
                })}
              </div>
            </div>

            {/* TEAM MINI CARD */}
            <div className="mt-4 rounded-[26px] border border-slate-200/80 dark:border-white/[0.07] bg-white dark:bg-[#101217] p-5 shadow-sm">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-[9px] font-black uppercase tracking-[0.2em] text-slate-400">
                    Komanda
                  </p>

                  <p className="mt-1 text-lg font-black">
                    {totalTeam}
                  </p>
                </div>

                <div className="w-9 h-9 rounded-xl bg-blue-500/10 text-blue-500 flex items-center justify-center">
                  <Activity size={17} />
                </div>
              </div>

              <div className="mt-5 space-y-4">
                <div>
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-xs font-bold">
                      Sol qol
                    </span>

                    <span className="text-xs font-black text-violet-500">
                      {solGrupSayisi.total}
                    </span>
                  </div>

                  <div className="h-1.5 rounded-full bg-slate-100 dark:bg-white/[0.07] overflow-hidden">
                    <div
                      className="h-full rounded-full bg-violet-500 transition-all duration-500"
                      style={{
                        width: `${Math.min(
                          leftPercentage,
                          100
                        )}%`,
                      }}
                    />
                  </div>
                </div>

                <div>
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-xs font-bold">
                      Sağ qol
                    </span>

                    <span className="text-xs font-black text-blue-500">
                      {sagGrupSayisi.total}
                    </span>
                  </div>

                  <div className="h-1.5 rounded-full bg-slate-100 dark:bg-white/[0.07] overflow-hidden">
                    <div
                      className="h-full rounded-full bg-blue-500 transition-all duration-500"
                      style={{
                        width: `${Math.min(
                          rightPercentage,
                          100
                        )}%`,
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="mt-5 pt-4 border-t border-slate-100 dark:border-white/[0.06] flex items-center justify-between">
                <span className="text-[11px] text-slate-400">
                  Ödənişli
                </span>

                <span className="text-xs font-black text-emerald-500">
                  {paidTeam}
                </span>
              </div>
            </div>
          </aside>

          {/* MAIN CONTENT */}
          <main
            ref={scrollRef}
            className="min-w-0"
          >
            {/* =================================================
                PROFILE
            ================================================= */}

            {activeTab === "profile" && (
              <div className="space-y-6">
                {/* TOP INFO GRID */}
                <div className="grid grid-cols-1 xl:grid-cols-[1fr_1fr] gap-6">
                  {/* PERSONAL */}
                  <section className="rounded-[28px] border border-slate-200/80 dark:border-white/[0.07] bg-white dark:bg-[#101217] overflow-hidden shadow-sm">
                    <div className="p-4 sm:p-6 border-b border-slate-100 dark:border-white/[0.06]">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-[9px] font-black uppercase tracking-[0.2em] text-slate-400">
                            Hesab
                          </p>

                          <h3 className="mt-1.5 text-xl font-black tracking-tight">
                            Şəxsi məlumatlar
                          </h3>
                        </div>

                        <div className="w-10 h-10 rounded-xl bg-slate-100 dark:bg-white/[0.05] flex items-center justify-center">
                          <ShieldCheck
                            size={18}
                            className="text-slate-500"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="p-6">
                      <div className="space-y-1">
                        {[
                          [
                            "Ad Soyad",
                            userInfo?.name,
                            () =>
                              handleNameClickl(
                                userInfo?.referralCode
                              ),
                          ],
                          [
                            "Telefon",
                            userInfo?.phone,
                          ],
                          [
                            "FIN Kod",
                            userInfo?.finCode,
                          ],
                          [
                            "Ata Adı",
                            userInfo?.faze,
                          ],
                        ].map(
                          (
                            [label, value, action],
                            index
                          ) => (
                            <div
                              key={label}
                              className={`flex items-center justify-between gap-4 py-4 ${
                                index !== 3
                                  ? "border-b border-slate-100 dark:border-white/[0.05]"
                                  : ""
                              }`}
                            >
                              <span className="text-xs font-semibold text-slate-400">
                                {label}
                              </span>

                              <button
                                type="button"
                                onClick={action}
                                disabled={!action}
                                className={`text-sm font-bold text-right truncate max-w-[65%] ${
                                  action
                                    ? "text-blue-600 dark:text-blue-400 hover:underline"
                                    : ""
                                }`}
                              >
                                {value || "—"}
                              </button>
                            </div>
                          )
                        )}

                        <div className="pt-4 flex items-center justify-between">
                          <span className="text-xs font-semibold text-slate-400">
                            Ödəniş
                          </span>

                          <span
                            className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-[10px] font-black ${
                              userInfo?.payment
                                ? "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400"
                                : "bg-red-500/10 text-red-600 dark:text-red-400"
                            }`}
                          >
                            <span
                              className={`w-1.5 h-1.5 rounded-full ${
                                userInfo?.payment
                                  ? "bg-emerald-500"
                                  : "bg-red-500"
                              }`}
                            />

                            {userInfo?.payment
                              ? "Ödənilib"
                              : "Ödənilməyib"}
                          </span>
                        </div>
                      </div>

                      <button
                        type="button"
                        onClick={() =>
                          setShowInfo(
                            !showInfo
                          )
                        }
                        className="mt-5 w-full flex items-center justify-between rounded-2xl bg-slate-50 dark:bg-white/[0.035] border border-slate-100 dark:border-white/[0.05] p-4 text-left hover:bg-slate-100 dark:hover:bg-white/[0.055] transition-colors"
                      >
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 rounded-xl bg-blue-500/10 text-blue-500 flex items-center justify-center">
                            <Bell size={14} />
                          </div>

                          <span className="text-xs font-bold">
                            Referral məlumatları
                          </span>
                        </div>

                        <ChevronRight
                          size={15}
                          className={`text-slate-400 transition-transform ${
                            showInfo
                              ? "rotate-90"
                              : ""
                          }`}
                        />
                      </button>

                      {showInfo && (
                        <div className="mt-3 rounded-2xl bg-blue-500/[0.05] border border-blue-500/10 p-4">
                          <p className="text-xs leading-6 text-slate-500 dark:text-slate-400">
                            Adınıza klikləməklə sizi dəvət edən
                            şəxs və lider haqqında məlumatları
                            görə bilərsiniz.
                          </p>
                        </div>
                      )}
                    </div>
                  </section>

                  {/* PAYMENT */}
                  <section className="rounded-[28px] border border-slate-200/80 dark:border-white/[0.07] bg-white dark:bg-[#101217] overflow-hidden shadow-sm">
                    <div className="p-4 sm:p-6 border-b border-slate-100 dark:border-white/[0.06]">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-[9px] font-black uppercase tracking-[0.2em] text-slate-400">
                            Ödəniş
                          </p>

                          <h3 className="mt-1.5 text-xl font-black tracking-tight">
                            Kart və dəvət məlumatları
                          </h3>
                        </div>

                        <div className="w-10 h-10 rounded-xl bg-emerald-500/10 text-emerald-500 flex items-center justify-center">
                          <CreditCard size={18} />
                        </div>
                      </div>
                    </div>

                    <form
                      onSubmit={handleSubmit}
                      className="p-6 space-y-5"
                    >
                      <div>
                        <label
                          htmlFor="card-input"
                          className="text-[10px] font-black uppercase tracking-[0.14em] text-slate-400"
                        >
                          Kart nömrəsi
                        </label>

                        <div className="relative mt-2">
                          <CreditCard
                            size={16}
                            className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400"
                          />

                          <input
                            id="card-input"
                            type="text"
                            value={card}
                            onChange={(e) =>
                              setCard(
                                e.target.value
                              )
                            }
                            placeholder="0000 0000 0000 0000"
                            className="w-full h-12 rounded-2xl border border-slate-200 dark:border-white/[0.08] bg-slate-50 dark:bg-white/[0.035] pl-11 pr-4 outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 transition-all text-sm font-semibold"
                          />
                        </div>
                      </div>

                      {/* USER CODE */}
                      <div className="rounded-2xl border border-slate-200 dark:border-white/[0.07] overflow-hidden">
                        <div className="px-4 py-3 bg-slate-50 dark:bg-white/[0.025] border-b border-slate-200 dark:border-white/[0.06]">
                          <div className="flex items-center gap-2">
                            <Link2
                              size={13}
                              className="text-slate-400"
                            />

                            <span className="text-[10px] font-black uppercase tracking-wider text-slate-400">
                              İstifadəçi kodu
                            </span>
                          </div>
                        </div>

                        <div className="flex items-center gap-2 p-2">
                          <span className="flex-1 px-3 text-sm font-black truncate">
                            {referralLink || "—"}
                          </span>

                          <button
                            type="button"
                            onClick={
                              copyReferralLinke
                            }
                            className="shrink-0 h-9 px-3.5 rounded-xl bg-slate-950 dark:bg-white text-white dark:text-slate-950 text-[11px] font-black flex items-center gap-1.5 hover:opacity-90"
                          >
                            <Copy size={13} />
                            Kopyala
                          </button>
                        </div>
                      </div>

                      {/* REFERRAL LINK */}
                      <div className="rounded-2xl border border-slate-200 dark:border-white/[0.07] overflow-hidden">
                        <div className="px-4 py-3 bg-slate-50 dark:bg-white/[0.025] border-b border-slate-200 dark:border-white/[0.06]">
                          <div className="flex items-center gap-2">
                            <ExternalLink
                              size={13}
                              className="text-slate-400"
                            />

                            <span className="text-[10px] font-black uppercase tracking-wider text-slate-400">
                              Dəvət linki
                            </span>
                          </div>
                        </div>

                        <div className="flex items-center gap-2 p-2">
                          <a
                            href={`${window.location.origin}/register?referral=${referralLink}`}
                            target="_blank"
                            rel="noreferrer"
                            className="flex-1 px-3 text-xs font-bold text-blue-600 dark:text-blue-400 truncate hover:underline"
                          >
                            {`${window.location.origin}/register?referral=${referralLink}`}
                          </a>

                          <button
                            type="button"
                            onClick={
                              copyReferralLink
                            }
                            className="shrink-0 h-9 px-3.5 rounded-xl bg-blue-600 text-white text-[11px] font-black flex items-center gap-1.5 hover:bg-blue-700"
                          >
                            <Copy size={13} />
                            Kopyala
                          </button>
                        </div>
                      </div>

                      <button
                        type="submit"
                        className="w-full h-12 rounded-2xl bg-slate-950 dark:bg-white text-white dark:text-slate-950 text-sm font-black flex items-center justify-center gap-2 hover:opacity-90 transition-opacity"
                      >
                        <Save size={16} />
                        Məlumatları yenilə
                      </button>
                    </form>
                  </section>
                </div>

                {/* DASHBOARD METRICS */}
                <div className="grid grid-cols-2 xl:grid-cols-4 gap-4">
                  <StatCard
                    label="Komanda"
                    value={totalTeam}
                    suffix="üzv"
                    icon={Users}
                    accent="blue"
                  />

                  <StatCard
                    label="Sol qol"
                    value={solGrupSayisi.total}
                    suffix={`${solGrupSayisi.paid} ödənişli`}
                    icon={GitBranchIcon}
                    accent="violet"
                  />

                  <StatCard
                    label="Sağ qol"
                    value={sagGrupSayisi.total}
                    suffix={`${sagGrupSayisi.paid} ödənişli`}
                    icon={GitBranchIcon}
                    accent="blue"
                  />

                  <StatCard
                    label="Ümumi qazanc"
                    value={
                      stats?.totalEarned || 0
                    }
                    suffix="₼"
                    icon={BarChart3}
                    accent="emerald"
                  />
                </div>

                {error && (
                  <div className="rounded-2xl border border-red-500/15 bg-red-500/[0.05] px-4 py-3 flex items-center gap-3 text-sm font-semibold text-red-600 dark:text-red-400">
                    <Bell size={16} />
                    {error}
                  </div>
                )}
              </div>
            )}

            {/* =================================================
                GROUPS
            ================================================= */}

            {activeTab === "groups" && (
              <div className="space-y-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {/* LEFT */}
                  <div className="relative overflow-hidden rounded-[28px] border border-violet-500/15 bg-white dark:bg-[#101217] p-6">
                    <div className="absolute -right-12 -top-12 w-36 h-36 rounded-full bg-violet-500/10 blur-3xl" />

                    <div className="relative">
                      <div className="flex items-center justify-between">
                        <div className="w-11 h-11 rounded-2xl bg-violet-500/10 text-violet-500 flex items-center justify-center">
                          <GitBranchIcon />
                        </div>

                        <span className="text-[10px] font-black uppercase tracking-wider text-violet-500">
                          Sol
                        </span>
                      </div>

                      <p className="mt-6 text-4xl font-black tracking-[-0.05em]">
                        {solGrupSayisi.total}
                      </p>

                      <p className="mt-1 text-sm text-slate-400">
                        {solGrupSayisi.paid} ödənişli üzv
                      </p>

                      <div className="mt-5 h-1.5 rounded-full bg-violet-500/10 overflow-hidden">
                        <div
                          className="h-full rounded-full bg-violet-500"
                          style={{
                            width: `${Math.min(
                              leftPercentage,
                              100
                            )}%`,
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* RIGHT */}
                  <div className="relative overflow-hidden rounded-[28px] border border-blue-500/15 bg-white dark:bg-[#101217] p-6">
                    <div className="absolute -right-12 -top-12 w-36 h-36 rounded-full bg-blue-500/10 blur-3xl" />

                    <div className="relative">
                      <div className="flex items-center justify-between">
                        <div className="w-11 h-11 rounded-2xl bg-blue-500/10 text-blue-500 flex items-center justify-center">
                          <GitBranchIcon />
                        </div>

                        <span className="text-[10px] font-black uppercase tracking-wider text-blue-500">
                          Sağ
                        </span>
                      </div>

                      <p className="mt-6 text-4xl font-black tracking-[-0.05em]">
                        {sagGrupSayisi.total}
                      </p>

                      <p className="mt-1 text-sm text-slate-400">
                        {sagGrupSayisi.paid} ödənişli üzv
                      </p>

                      <div className="mt-5 h-1.5 rounded-full bg-blue-500/10 overflow-hidden">
                        <div
                          className="h-full rounded-full bg-blue-500"
                          style={{
                            width: `${Math.min(
                              rightPercentage,
                              100
                            )}%`,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <section className="rounded-[28px] border border-slate-200/80 dark:border-white/[0.07] bg-white dark:bg-[#101217] overflow-hidden shadow-sm">
                  <div className="p-4 sm:p-6 border-b border-slate-100 dark:border-white/[0.06] flex items-center justify-between">
                    <div>
                      <p className="text-[9px] font-black uppercase tracking-[0.2em] text-slate-400">
                        Komanda
                      </p>

                      <h3 className="mt-1.5 text-xl font-black">
                        Sağ və sol qollar
                      </h3>
                    </div>

                    <span className="px-3 py-1.5 rounded-full bg-slate-100 dark:bg-white/[0.05] text-[10px] font-black">
                      {referredUsers.length} üzv
                    </span>
                  </div>

                  {referredUsers.length ? (
                    <div className="divide-y divide-slate-100 dark:divide-white/[0.05]">
                      {referredUsers.map(
                        (user) => {
                          const right =
                            String(
                              user.side || ""
                            )
                              .trim()
                              .toLowerCase() ===
                            "right";

                          return (
                            <div
                              key={user._id}
                              className="p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-4 hover:bg-slate-50 dark:hover:bg-white/[0.02] transition-colors"
                            >
                              <Avatar
                                user={user}
                                size="w-12 h-12"
                              />

                              <div className="min-w-0 flex-1">
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleNameClick(
                                      user.referralCode
                                    )
                                  }
                                  className="font-black text-sm hover:text-blue-600 dark:hover:text-blue-400 truncate"
                                >
                                  {user.name}
                                </button>

                                <p className="text-xs text-slate-400 mt-1 truncate">
                                  {user.email} ·{" "}
                                  {user.referralCode}
                                </p>
                              </div>

                              <div className="flex flex-wrap gap-2">
                                <span
                                  className={`px-3 py-1.5 rounded-full text-[10px] font-black ${
                                    right
                                      ? "bg-blue-500/10 text-blue-600 dark:text-blue-400"
                                      : "bg-violet-500/10 text-violet-600 dark:text-violet-400"
                                  }`}
                                >
                                  {right
                                    ? "Sağ qol"
                                    : "Sol qol"}
                                </span>

                                <span
                                  className={`px-3 py-1.5 rounded-full text-[10px] font-black ${
                                    user.payment
                                      ? "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400"
                                      : "bg-red-500/10 text-red-600 dark:text-red-400"
                                  }`}
                                >
                                  {user.payment
                                    ? "Ödənilib"
                                    : "Ödənilməyib"}
                                </span>
                              </div>

                              <span className="text-[11px] font-semibold text-slate-400">
                                {user.createdAt
                                  ? new Date(
                                      user.createdAt
                                    ).toLocaleDateString()
                                  : "—"}
                              </span>
                            </div>
                          );
                        }
                      )}
                    </div>
                  ) : (
                    <EmptyState
                      icon={GitBranchIcon}
                      title="Qol üzvü yoxdur"
                      description="Hazırda sağ və ya sol qolda istifadəçi görünmür."
                    />
                  )}
                </section>
              </div>
            )}

            {/* =================================================
                ALL GROUPS
            ================================================= */}

            {activeTab === "qrouplar" && (
              <section className="rounded-[28px] border border-slate-200/80 dark:border-white/[0.07] bg-white dark:bg-[#101217] overflow-hidden shadow-sm">
                <div className="p-4 sm:p-6 border-b border-slate-100 dark:border-white/[0.06]">
                  <div className="flex flex-col lg:flex-row lg:items-end gap-4 justify-between">
                    <div>
                      <p className="text-[9px] font-black uppercase tracking-[0.2em] text-slate-400">
                        Komanda
                      </p>

                      <h3 className="mt-1.5 text-xl font-black">
                        Bütün qruplar
                      </h3>

                      <p className="mt-1 text-sm text-slate-400">
                        Komandanızdakı bütün istifadəçilər.
                      </p>
                    </div>

                    <div className="flex flex-col sm:flex-row gap-2 w-full lg:w-auto">
                      <div className="relative">
                        <Search
                          size={15}
                          className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400"
                        />

                        <input
                          type="text"
                          placeholder="Ad / kod ilə axtarış"
                          value={searchTerm}
                          onChange={(e) =>
                            setSearchTerm(
                              e.target.value
                            )
                          }
                          className="h-11 w-full sm:w-64 rounded-xl border border-slate-200 dark:border-white/[0.08] bg-slate-50 dark:bg-white/[0.035] pl-10 pr-4 text-sm outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10"
                        />
                      </div>

                      <select
                        value={
                          paymentFilters ===
                          null
                            ? ""
                            : paymentFilters
                            ? "paid"
                            : "unpaid"
                        }
                        onChange={(e) => {
                          const value =
                            e.target.value;

                          setPaymentFilters(
                            value === "paid"
                              ? true
                              : value ===
                                "unpaid"
                              ? false
                              : null
                          );
                        }}
                        className="h-11 rounded-xl border border-slate-200 dark:border-white/[0.08] bg-slate-50 dark:bg-white/[0.035] px-3 text-xs font-bold outline-none focus:border-blue-500"
                      >
                        <option value="">
                          Bütün ödənişlər
                        </option>
                        <option value="paid">
                          Ödəniş edənlər
                        </option>
                        <option value="unpaid">
                          Ödəniş etməyənlər
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                {filteredUsers.length ? (
                  <div className="max-h-[420px] overflow-auto overscroll-contain rounded-b-2xl">
                    <div className="min-w-[680px] divide-y divide-slate-100 dark:divide-white/[0.05]">
                    {filteredUsers.map(
                      (user, index) => (
                        <div
                          key={user._id}
                          className="p-4 sm:p-5 flex items-center gap-3 sm:gap-4 hover:bg-slate-50 dark:hover:bg-white/[0.02] transition-colors"
                        >
                          <span className="hidden sm:block w-7 text-[10px] font-black text-slate-300">
                            {String(
                              index + 1
                            ).padStart(2, "0")}
                          </span>

                          <Avatar user={user} />

                          <div className="min-w-0 flex-1">
                            <button
                              type="button"
                              onClick={() =>
                                handleNameClick(
                                  user.referralCode
                                )
                              }
                              className="font-black text-sm hover:text-blue-600 dark:hover:text-blue-400 truncate block"
                            >
                              {user.name}
                            </button>

                            <p className="text-xs text-slate-400 truncate mt-0.5">
                              {user.email} ·{" "}
                              {user.referralCode}
                            </p>
                          </div>

                          <span
                            className={`hidden sm:inline-flex px-2.5 py-1.5 rounded-full text-[10px] font-black ${
                              user.payment
                                ? "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400"
                                : "bg-red-500/10 text-red-600 dark:text-red-400"
                            }`}
                          >
                            {user.payment
                              ? "Ödənişli"
                              : "Ödənişsiz"}
                          </span>

                          <span className="hidden sm:block text-[11px] text-slate-400">
                            {user.createdAt
                              ? new Date(
                                  user.createdAt
                                ).toLocaleDateString()
                              : "—"}
                          </span>

                          <ChevronRight
                            size={15}
                            className="text-slate-300 dark:text-slate-600"
                          />
                        </div>
                      )
                    )}
                    </div>
                  </div>
                ) : (
                  <EmptyState
                    icon={Search}
                    title="İstifadəçi tapılmadı"
                    description="Axtarış və ödəniş filtrlərinə uyğun nəticə yoxdur."
                  />
                )}
              </section>
            )}

            {/* =================================================
                REFERRALS
            ================================================= */}

            {activeTab === "referrals" && (
              <section className="rounded-[28px] border border-slate-200/80 dark:border-white/[0.07] bg-white dark:bg-[#101217] overflow-hidden shadow-sm">
                <div className="p-4 sm:p-6 border-b border-slate-100 dark:border-white/[0.06]">
                  <div className="flex flex-col lg:flex-row lg:items-end gap-4 justify-between">
                    <div>
                      <p className="text-[9px] font-black uppercase tracking-[0.2em] text-slate-400">
                        Referral
                      </p>

                      <h3 className="mt-1.5 text-xl font-black">
                        Şəxsi dəvətlilər
                      </h3>

                      <p className="mt-1 text-sm text-slate-400">
                        Sizin birbaşa dəvət etdiyiniz istifadəçilər.
                      </p>
                    </div>

                    <div className="flex flex-col sm:flex-row gap-2 w-full lg:w-auto">
                      <div className="relative">
                        <Search
                          size={15}
                          className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400"
                        />

                        <input
                          type="text"
                          placeholder="Ad / kod ilə axtarış"
                          value={searchTert}
                          onChange={(e) =>
                            setSearchTert(
                              e.target.value
                            )
                          }
                          className="h-11 w-full sm:w-64 rounded-xl border border-slate-200 dark:border-white/[0.08] bg-slate-50 dark:bg-white/[0.035] pl-10 pr-4 text-sm outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10"
                        />
                      </div>

                      <select
                        value={
                          paymentFilter ===
                          null
                            ? ""
                            : paymentFilter
                            ? "paid"
                            : "unpaid"
                        }
                        onChange={(e) => {
                          const value =
                            e.target.value;

                          setPaymentFilter(
                            value === "paid"
                              ? true
                              : value ===
                                "unpaid"
                              ? false
                              : null
                          );
                        }}
                        className="h-11 rounded-xl border border-slate-200 dark:border-white/[0.08] bg-slate-50 dark:bg-white/[0.035] px-3 text-xs font-bold outline-none"
                      >
                        <option value="">
                          Bütün ödənişlər
                        </option>
                        <option value="paid">
                          Ödəniş edənlər
                        </option>
                        <option value="unpaid">
                          Ödəniş etməyənlər
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                {filteredUserz.length ? (
                  <div className="max-h-[420px] overflow-auto overscroll-contain rounded-b-2xl">
                    <div className="min-w-[680px] divide-y divide-slate-100 dark:divide-white/[0.05]">
                    {filteredUserz.map(
                      (user, index) => (
                        <div
                          key={user._id}
                          className="p-4 sm:p-5 flex items-center gap-3 sm:gap-4 hover:bg-slate-50 dark:hover:bg-white/[0.02] transition-colors"
                        >
                          <span className="hidden sm:block w-7 text-[10px] font-black text-slate-300">
                            {String(
                              index + 1
                            ).padStart(2, "0")}
                          </span>

                          <Avatar user={user} />

                          <div className="min-w-0 flex-1">
                            <button
                              type="button"
                              onClick={() =>
                                handleNameClick(
                                  user.referralCode
                                )
                              }
                              className="font-black text-sm hover:text-blue-600 dark:hover:text-blue-400 truncate block"
                            >
                              {user.name}
                            </button>

                            <p className="text-xs text-slate-400 truncate mt-0.5">
                              {user.email} ·{" "}
                              {user.referralCode}
                            </p>
                          </div>

                          <span
                            className={`px-2.5 py-1.5 rounded-full text-[10px] font-black ${
                              user.payment
                                ? "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400"
                                : "bg-red-500/10 text-red-600 dark:text-red-400"
                            }`}
                          >
                            {user.payment
                              ? "Ödənişli"
                              : "Ödənişsiz"}
                          </span>

                          <span className="hidden sm:block text-[11px] text-slate-400">
                            {user.createdAt
                              ? new Date(
                                  user.createdAt
                                ).toLocaleDateString()
                              : "—"}
                          </span>
                        </div>
                      )
                    )}
                    </div>
                  </div>
                ) : (
                  <EmptyState
                    icon={UserPlus}
                    title="Dəvətli yoxdur"
                    description="Hazırda sizə bağlı birbaşa dəvətli istifadəçi görünmür."
                  />
                )}
              </section>
            )}

            {/* =================================================
                ADS
            ================================================= */}

            {activeTab === "elanlar" && (
              <div className="space-y-6">
                <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
                  <div>
                    <p className="text-[9px] font-black uppercase tracking-[0.2em] text-slate-400">
                      Marketplace
                    </p>

                    <h2 className="mt-1.5 text-2xl font-black tracking-tight">
                      Elanlarım
                    </h2>

                    <p className="mt-1 text-sm text-slate-400">
                      Elanlarınızı idarə edin, redaktə edin və silin.
                    </p>
                  </div>

                  <div className="inline-flex self-start sm:self-auto items-center gap-2 px-3.5 py-2 rounded-xl bg-white dark:bg-[#101217] border border-slate-200 dark:border-white/[0.07] text-xs font-black">
                    <FileText
                      size={14}
                      className="text-slate-400"
                    />
                    {elanData.length} elan
                  </div>
                </div>

                {/* LOADING */}
                {loading && (
                  <div className="rounded-[24px] border border-blue-500/10 bg-blue-500/[0.04] p-4 flex items-center gap-3">
                    <div className="w-9 h-9 rounded-xl bg-blue-500/10 text-blue-500 flex items-center justify-center">
                      <Loader2
                        size={17}
                        className="animate-spin"
                      />
                    </div>

                    <div>
                      <p className="text-sm font-black">
                        Elanlar yüklənir...
                      </p>

                      <p className="text-xs text-slate-400 mt-0.5">
                        Məlumatlar serverdən alınır.
                      </p>
                    </div>
                  </div>
                )}

                {/* ERROR */}
                {error && (
                  <div className="rounded-[24px] border border-red-500/10 bg-red-500/[0.04] p-4 flex items-center justify-between gap-4">
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 rounded-xl bg-red-500/10 text-red-500 flex items-center justify-center">
                        <Bell size={16} />
                      </div>

                      <p className="text-sm font-semibold text-red-600 dark:text-red-400">
                        {error}
                      </p>
                    </div>

                    <button
                      type="button"
                      onClick={
                        fetchElanData
                      }
                      className="shrink-0 h-9 px-3 rounded-xl bg-red-600 text-white text-[11px] font-black flex items-center gap-1.5"
                    >
                      <RefreshCw size={13} />
                      Yenilə
                    </button>
                  </div>
                )}

                {/* EMPTY */}
                {!loading &&
                  !elanData.length && (
                    <div className="rounded-[28px] border border-dashed border-slate-300 dark:border-white/[0.08] bg-white dark:bg-[#101217] p-16 text-center">
                      <div className="w-14 h-14 rounded-2xl bg-slate-100 dark:bg-white/[0.05] mx-auto flex items-center justify-center">
                        <ImageIcon
                          size={25}
                          className="text-slate-400"
                        />
                      </div>

                      <h3 className="mt-5 font-black">
                        Hələ heç bir elanınız yoxdur
                      </h3>

                      <p className="text-sm text-slate-400 mt-1">
                        Əlavə etdiyiniz elanlar burada görünəcək.
                      </p>
                    </div>
                  )}

                {/* ADS GRID */}
                {!loading &&
                  elanData.length > 0 && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3 sm:gap-5">
                      {elanData.map(
                        (ad) => (
                          <article
                            key={ad._id}
                            className="group overflow-hidden rounded-[28px] border border-slate-200/80 dark:border-white/[0.07] bg-white dark:bg-[#101217] shadow-sm hover:-translate-y-1 hover:shadow-[0_25px_60px_-30px_rgba(0,0,0,.4)] transition-all duration-300"
                          >
                            {/* IMAGE */}
                            <div className="relative h-64 bg-slate-100 dark:bg-black/20 overflow-hidden">
                              {ad.photo?.length ? (
                                <Swiper
                                  modules={[
                                    Pagination,
                                    Navigation,
                                  ]}
                                  pagination={{
                                    clickable:
                                      true,
                                    dynamicBullets:
                                      true,
                                  }}
                                  navigation
                                  className="h-full w-full"
                                >
                                  {ad.photo.map(
                                    (
                                      image,
                                      index
                                    ) => (
                                      <SwiperSlide
                                        key={
                                          index
                                        }
                                      >
                                        <img
                                          src={
                                            image
                                          }
                                          alt={`${ad.title || "Elan"} — şəkil ${
                                            index +
                                            1
                                          }`}
                                          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                                          onError={(
                                            e
                                          ) => {
                                            e.currentTarget.src =
                                              "https://via.placeholder.com/600x450?text=Sekil";
                                          }}
                                        />
                                      </SwiperSlide>
                                    )
                                  )}
                                </Swiper>
                              ) : (
                                <div className="w-full h-full flex items-center justify-center">
                                  <ImageIcon
                                    size={42}
                                    className="text-slate-300 dark:text-slate-700"
                                  />
                                </div>
                              )}

                              {/* STATUS */}
                              <div className="absolute top-3 left-3 z-10 flex flex-wrap gap-2">
                                <span
                                  className={`px-2.5 py-1.5 rounded-full text-[9px] font-black backdrop-blur-md ${
                                    ad.status ===
                                    "active"
                                      ? "bg-emerald-500 text-white"
                                      : ad.status ===
                                        "sold"
                                      ? "bg-red-500 text-white"
                                      : "bg-slate-950/75 text-white"
                                  }`}
                                >
                                  {ad.status ===
                                  "active"
                                    ? "Aktiv"
                                    : ad.status ===
                                      "sold"
                                    ? "Satıldı"
                                    : "Gizli"}
                                </span>

                                {ad.condition && (
                                  <span className="px-2.5 py-1.5 rounded-full bg-black/55 text-white text-[9px] font-black backdrop-blur-md">
                                    {ad.condition ===
                                    "new"
                                      ? "Yeni"
                                      : "İşlənmiş"}
                                  </span>
                                )}
                              </div>

                              {/* IMAGE COUNT */}
                              {ad.photo?.length >
                                1 && (
                                <div className="absolute bottom-3 right-3 z-10 px-2.5 py-1.5 rounded-full bg-black/60 backdrop-blur-md text-white text-[9px] font-black">
                                  {ad.photo.length} foto
                                </div>
                              )}
                            </div>

                            {/* BODY */}
                            <div className="p-5">
                              <div className="flex items-start justify-between gap-3">
                                <div className="min-w-0">
                                  <h3 className="font-black text-base truncate">
                                    {ad.title ||
                                      "Adsız elan"}
                                  </h3>

                                  <p className="text-xs text-slate-400 mt-1 truncate">
                                    {ad.category ||
                                      "Kateqoriya yoxdur"}
                                  </p>
                                </div>

                                <strong className="text-lg font-black text-blue-600 dark:text-blue-400 whitespace-nowrap">
                                  {ad.price} ₼
                                </strong>
                              </div>

                              <p className="text-sm text-slate-500 dark:text-slate-400 mt-3 line-clamp-2 min-h-[40px]">
                                {ad.description ||
                                  "Açıqlama yoxdur."}
                              </p>

                              <div className="grid grid-cols-2 gap-2 mt-4">
                                {ad.location && (
                                  <div className="rounded-xl bg-slate-50 dark:bg-white/[0.035] p-3">
                                    <span className="flex items-center gap-1.5 text-[9px] font-black uppercase text-slate-400">
                                      <MapPin
                                        size={10}
                                      />
                                      Ünvan
                                    </span>

                                    <span className="text-xs font-bold truncate block mt-1">
                                      {
                                        ad.location
                                      }
                                    </span>
                                  </div>
                                )}

                                {ad.stock !=
                                  null && (
                                  <div className="rounded-xl bg-slate-50 dark:bg-white/[0.035] p-3">
                                    <span className="flex items-center gap-1.5 text-[9px] font-black uppercase text-slate-400">
                                      <PackageIcon />
                                      Stok
                                    </span>

                                    <span className="text-xs font-bold block mt-1">
                                      {ad.stock} ədəd
                                    </span>
                                  </div>
                                )}
                              </div>

                              <div className="flex items-center gap-2 mt-4">
                                <button
                                  type="button"
                                  onClick={() =>
                                    setEditingAd(
                                      ad
                                    )
                                  }
                                  className="flex-1 h-11 rounded-xl bg-slate-950 dark:bg-white text-white dark:text-slate-950 text-xs font-black flex items-center justify-center gap-2 hover:opacity-90 transition-opacity"
                                >
                                  <Edit3
                                    size={14}
                                  />
                                  Redaktə et
                                </button>

                                <button
                                  type="button"
                                  onClick={() =>
                                    handleDeleteAd(
                                      ad._id
                                    )
                                  }
                                  disabled={
                                    deletingAdId ===
                                    ad._id
                                  }
                                  className="w-11 h-11 rounded-xl bg-red-500/10 text-red-600 dark:text-red-400 flex items-center justify-center disabled:opacity-50 hover:bg-red-500/15 transition-colors"
                                >
                                  {deletingAdId ===
                                  ad._id ? (
                                    <Loader2
                                      size={16}
                                      className="animate-spin"
                                    />
                                  ) : (
                                    <Trash2
                                      size={16}
                                    />
                                  )}
                                </button>
                              </div>
                            </div>
                          </article>
                        )
                      )}
                    </div>
                  )}

                {/* =================================================
                    EDIT MODAL
                ================================================= */}

                {editingAd && (
                  <div className="fixed inset-0 z-[100] bg-slate-950/70 backdrop-blur-xl p-3 sm:p-6 flex items-center justify-center">
                    <div className="w-[calc(100%-20px)] sm:w-full max-w-5xl max-h-[92dvh] overflow-hidden rounded-[30px] border border-white/[0.08] bg-white dark:bg-[#101217] shadow-[0_40px_100px_-30px_rgba(0,0,0,.6)] flex flex-col">
                      {/* MODAL HEADER */}
                      <div className="px-5 sm:px-7 py-5 border-b border-slate-200 dark:border-white/[0.06] flex items-center justify-between">
                        <div>
                          <p className="text-[9px] font-black uppercase tracking-[0.2em] text-slate-400">
                            Editor
                          </p>

                          <h3 className="text-xl font-black mt-1">
                            Elanı redaktə et
                          </h3>
                        </div>

                        <button
                          type="button"
                          onClick={() => {
                            setEditingAd(
                              null
                            );
                            setNewPhotos([]);
                          }}
                          className="w-10 h-10 rounded-xl bg-slate-100 dark:bg-white/[0.05] flex items-center justify-center hover:bg-slate-200 dark:hover:bg-white/[0.08] transition-colors"
                        >
                          <X size={18} />
                        </button>
                      </div>

                      {/* FORM */}
                      <form
                        onSubmit={
                          handleUpdateAd
                        }
                        className="overflow-y-auto p-5 sm:p-7 space-y-7"
                      >
                        {/* PHOTOS */}
                        <div>
                          <div className="flex items-center justify-between mb-3">
                            <div>
                              <label className="text-[10px] font-black uppercase tracking-wider text-slate-400">
                                Fotolar
                              </label>

                              <p className="text-xs text-slate-400 mt-1">
                                Elanın şəkillərini idarə edin.
                              </p>
                            </div>

                            <span className="text-[11px] font-bold text-slate-400">
                              {editingAd.photo
                                ?.length || 0}{" "}
                              mövcud ·{" "}
                              {newPhotos.length}{" "}
                              yeni
                            </span>
                          </div>

                          <div className="grid grid-cols-3 sm:grid-cols-5 md:grid-cols-6 gap-3">
                            {editingAd.photo?.map(
                              (
                                url,
                                index
                              ) => (
                                <div
                                  key={`old-${index}`}
                                  className="relative aspect-square rounded-2xl overflow-hidden group bg-slate-100 dark:bg-white/[0.04]"
                                >
                                  <img
                                    src={url}
                                    className="w-full h-full object-cover"
                                    alt="Elan"
                                  />

                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleDeleteSinglePhoto(
                                        editingAd._id,
                                        url
                                      )
                                    }
                                    disabled={
                                      deletingPhotoUrl ===
                                      url
                                    }
                                    className="absolute inset-0 m-auto w-9 h-9 rounded-xl bg-red-600 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                                  >
                                    {deletingPhotoUrl ===
                                    url ? (
                                      <Loader2
                                        size={15}
                                        className="animate-spin"
                                      />
                                    ) : (
                                      <Trash2
                                        size={15}
                                      />
                                    )}
                                  </button>
                                </div>
                              )
                            )}

                            {newPhotos.map(
                              (
                                file,
                                index
                              ) => (
                                <div
                                  key={`new-${index}`}
                                  className="relative aspect-square rounded-2xl overflow-hidden border-2 border-emerald-500"
                                >
                                  <img
                                    src={URL.createObjectURL(
                                      file
                                    )}
                                    className="w-full h-full object-cover"
                                    alt="Yeni"
                                  />

                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleDeleteNewPhoto(
                                        index
                                      )
                                    }
                                    className="absolute top-1 right-1 w-7 h-7 rounded-lg bg-red-600 text-white flex items-center justify-center"
                                  >
                                    <X size={13} />
                                  </button>
                                </div>
                              )
                            )}

                            <label className="aspect-square rounded-2xl border-2 border-dashed border-slate-300 dark:border-white/[0.08] flex flex-col items-center justify-center cursor-pointer hover:border-blue-500 hover:bg-blue-500/[0.04] transition-all">
                              <Plus
                                size={22}
                                className="text-blue-500"
                              />

                              <span className="text-[10px] font-black text-slate-400 mt-1">
                                Əlavə et
                              </span>

                              <input
                                type="file"
                                multiple
                                accept="image/*"
                                className="hidden"
                                onChange={(
                                  e
                                ) => {
                                  const files =
                                    Array.from(
                                      e.target
                                        .files ||
                                        []
                                    );

                                  setNewPhotos(
                                    (
                                      prev
                                    ) => [
                                      ...prev,
                                      ...files,
                                    ]
                                  );

                                  e.target.value =
                                    "";
                                }}
                              />
                            </label>
                          </div>
                        </div>

                        {/* FIELDS */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          {[
                            [
                              "title",
                              "Elanın başlığı",
                              "text",
                            ],
                            [
                              "category",
                              "Kateqoriya",
                              "text",
                            ],
                            [
                              "price",
                              "Qiymət (AZN)",
                              "number",
                            ],
                            [
                              "brand",
                              "Marka",
                              "text",
                            ],
                            [
                              "model",
                              "Model",
                              "text",
                            ],
                            [
                              "stock",
                              "Stok",
                              "number",
                            ],
                            [
                              "location",
                              "Ünvan",
                              "text",
                            ],
                            [
                              "distance",
                              "Məsafə (km)",
                              "text",
                            ],
                            [
                              "phone",
                              "Telefon",
                              "text",
                            ],
                            [
                              "warranty",
                              "Zəmanət",
                              "text",
                            ],
                          ].map(
                            ([
                              key,
                              label,
                              type,
                            ]) => (
                              <div
                                key={key}
                              >
                                <label className="text-[10px] font-black uppercase tracking-wider text-slate-400">
                                  {label}
                                </label>

                                <input
                                  type={type}
                                  value={
                                    editingAd[
                                      key
                                    ] ??
                                    (key ===
                                    "stock"
                                      ? 1
                                      : "")
                                  }
                                  onChange={(e) =>
                                    setEditingAd(
                                      {
                                        ...editingAd,
                                        [key]:
                                          e
                                            .target
                                            .value,
                                      }
                                    )
                                  }
                                  className="mt-1.5 w-full h-12 rounded-xl border border-slate-200 dark:border-white/[0.08] bg-slate-50 dark:bg-white/[0.035] px-4 text-sm font-semibold outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 transition-all"
                                />
                              </div>
                            )
                          )}

                          {/* STATUS */}
                          <div>
                            <label className="text-[10px] font-black uppercase tracking-wider text-slate-400">
                              Status
                            </label>

                            <select
                              value={
                                editingAd.status ||
                                "active"
                              }
                              onChange={(e) =>
                                setEditingAd({
                                  ...editingAd,
                                  status:
                                    e.target
                                      .value,
                                })
                              }
                              className="mt-1.5 w-full h-12 rounded-xl border border-slate-200 dark:border-white/[0.08] bg-slate-50 dark:bg-white/[0.035] px-4 text-sm font-semibold outline-none focus:border-blue-500"
                            >
                              <option value="active">
                                Aktiv
                              </option>

                              <option value="sold">
                                Satıldı
                              </option>

                              <option value="hidden">
                                Gizli
                              </option>
                            </select>
                          </div>

                          {/* CONDITION */}
                          <div>
                            <label className="text-[10px] font-black uppercase tracking-wider text-slate-400">
                              Vəziyyəti
                            </label>

                            <select
                              value={
                                editingAd.condition ||
                                "new"
                              }
                              onChange={(e) =>
                                setEditingAd({
                                  ...editingAd,
                                  condition:
                                    e.target
                                      .value,
                                })
                              }
                              className="mt-1.5 w-full h-12 rounded-xl border border-slate-200 dark:border-white/[0.08] bg-slate-50 dark:bg-white/[0.035] px-4 text-sm font-semibold outline-none focus:border-blue-500"
                            >
                              <option value="new">
                                Yeni
                              </option>

                              <option value="used">
                                İşlənmiş
                              </option>
                            </select>
                          </div>
                        </div>

                        {/* DESCRIPTION */}
                        <div>
                          <label className="text-[10px] font-black uppercase tracking-wider text-slate-400">
                            Açıqlama
                          </label>

                          <textarea
                            rows="5"
                            value={
                              editingAd.description ||
                              ""
                            }
                            onChange={(e) =>
                              setEditingAd({
                                ...editingAd,
                                description:
                                  e.target
                                    .value,
                              })
                            }
                            className="mt-1.5 w-full rounded-xl border border-slate-200 dark:border-white/[0.08] bg-slate-50 dark:bg-white/[0.035] p-4 text-sm font-medium outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 resize-none"
                          />
                        </div>

                        {/* CHECKBOXES */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                          <label className="flex items-center gap-3 p-4 rounded-2xl border border-slate-200 dark:border-white/[0.07] bg-slate-50 dark:bg-white/[0.025] cursor-pointer hover:bg-slate-100 dark:hover:bg-white/[0.045]">
                            <input
                              type="checkbox"
                              checked={
                                editingAd.negotiable ||
                                false
                              }
                              onChange={(e) =>
                                setEditingAd({
                                  ...editingAd,
                                  negotiable:
                                    e.target
                                      .checked,
                                })
                              }
                              className="w-4 h-4 accent-blue-600"
                            />

                            <span className="text-xs font-bold">
                              Qiymət razılaşma yolu ilə
                            </span>
                          </label>

                          <label className="flex items-center gap-3 p-4 rounded-2xl border border-slate-200 dark:border-white/[0.07] bg-slate-50 dark:bg-white/[0.025] cursor-pointer hover:bg-slate-100 dark:hover:bg-white/[0.045]">
                            <input
                              type="checkbox"
                              checked={
                                editingAd.delivery ||
                                false
                              }
                              onChange={(e) =>
                                setEditingAd({
                                  ...editingAd,
                                  delivery:
                                    e.target
                                      .checked,
                                })
                              }
                              className="w-4 h-4 accent-blue-600"
                            />

                            <span className="text-xs font-bold">
                              Çatdırılma var
                            </span>
                          </label>
                        </div>

                        {/* ACTIONS */}
                        <div className="sticky bottom-0 -mx-5 sm:-mx-7 -mb-5 sm:-mb-7 p-5 sm:p-7 bg-white/95 dark:bg-[#101217]/95 backdrop-blur-xl border-t border-slate-200 dark:border-white/[0.06] flex gap-3">
                          <button
                            type="button"
                            onClick={() => {
                              setEditingAd(
                                null
                              );
                              setNewPhotos([]);
                            }}
                            className="flex-1 h-12 rounded-xl bg-slate-100 dark:bg-white/[0.05] text-sm font-black hover:bg-slate-200 dark:hover:bg-white/[0.08] transition-colors"
                          >
                            Ləğv et
                          </button>

                          <button
                            type="submit"
                            disabled={uploading}
                            className="flex-[2] h-12 rounded-xl bg-slate-950 dark:bg-white text-white dark:text-slate-950 text-sm font-black flex items-center justify-center gap-2 disabled:opacity-50 hover:opacity-90 transition-opacity"
                          >
                            {uploading ? (
                              <Loader2
                                size={18}
                                className="animate-spin"
                              />
                            ) : (
                              <Save size={18} />
                            )}

                            {uploading
                              ? "Yadda saxlanılır..."
                              : "Yadda saxla"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                )}
              </div>
            )}
          </main>
        </div>
      </div>

      {/* =======================================================
          REFERRER MODAL
      ======================================================= */}

      {(showModal || showModa) && (
        <div
          className="fixed inset-0 z-[110] bg-slate-950/70 backdrop-blur-xl p-4 flex items-center justify-center"
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) {
              closeReferralModal();
            }
          }}
        >
          <div className="w-full max-w-xl rounded-[30px] border border-white/[0.08] bg-white dark:bg-[#101217] shadow-[0_40px_100px_-30px_rgba(0,0,0,.6)] overflow-hidden">
            {/* HEADER */}
            <div className="p-4 sm:p-6 border-b border-slate-200 dark:border-white/[0.06] flex items-center justify-between">
              <div>
                <p className="text-[9px] font-black uppercase tracking-[0.2em] text-slate-400">
                  Referral network
                </p>

                <h3 className="text-xl font-black mt-1">
                  Dəvət məlumatları
                </h3>
              </div>

              <button
                type="button"
                onClick={
                  closeReferralModal
                }
                className="w-10 h-10 rounded-xl bg-slate-100 dark:bg-white/[0.05] flex items-center justify-center hover:bg-slate-200 dark:hover:bg-white/[0.08]"
              >
                <X size={18} />
              </button>
            </div>

            {/* BODY */}
            <div className="p-5 sm:p-6 space-y-3">
              {[
                [
                  showModa
                    ? referrerInf
                    : referrerInfo,
                  "Dəvət edən şəxs",
                  "blue",
                ],
                [
                  showModa
                    ? referrerInfs
                    : referrerInfoo,
                  "Lider",
                  "violet",
                ],
              ].map(
                ([person, title, color]) => (
                  <div
                    key={title}
                    className={`rounded-[24px] border p-5 ${
                      color === "blue"
                        ? "border-blue-500/10 bg-blue-500/[0.035]"
                        : "border-violet-500/10 bg-violet-500/[0.035]"
                    }`}
                  >
                    <div className="flex items-center justify-between">
                      <p className="text-[9px] font-black uppercase tracking-wider text-slate-400">
                        {title}
                      </p>

                      <div
                        className={`w-8 h-8 rounded-xl flex items-center justify-center ${
                          color ===
                          "blue"
                            ? "bg-blue-500/10 text-blue-500"
                            : "bg-violet-500/10 text-violet-500"
                        }`}
                      >
                        {color ===
                        "blue" ? (
                          <UserPlus
                            size={14}
                          />
                        ) : (
                          <ShieldCheck
                            size={14}
                          />
                        )}
                      </div>
                    </div>

                    {person?.error ? (
                      <p className="mt-4 text-sm font-semibold text-red-500">
                        {person.error}
                      </p>
                    ) : (
                      <div className="flex items-center gap-4 mt-5">
                        {person?.referrerPhoto ? (
                          <img
                            src={
                              person.referrerPhoto
                            }
                            alt={title}
                            className="w-14 h-14 rounded-2xl object-cover"
                          />
                        ) : (
                          <div className="w-14 h-14 rounded-2xl bg-slate-100 dark:bg-white/[0.06] flex items-center justify-center">
                            <CircleUserRound
                              size={22}
                              className="text-slate-400"
                            />
                          </div>
                        )}

                        <div className="min-w-0">
                          <p className="font-black truncate">
                            {person?.referrerName ||
                              "Məlumat yoxdur"}
                          </p>

                          <p className="text-xs text-slate-400 mt-1 truncate">
                            {person?.referrerEmail ||
                              "—"}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

/* =============================================================
   EXTRA ICON
============================================================= */

const PackageIcon = ({
  size = 11,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="m16.5 9.4-9-5.19" />
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
    <path d="M3.27 6.96 12 12.01l8.73-5.05" />
    <path d="M12 22.08V12" />
  </svg>
);

export default Profile;